import request from '@/utils/request'

export function getList (filters = {}, pagination = {}) {
  return request({
    url: '/company',
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify(pagination)
    }
  })
}

export function getDetail (id) {
  const url = '/company/' + id
  return request({
    url,
    method: 'get'
  })
}

export function upsert (data) {
  var method = 'post'
  var url = '/company'
  if (data.id) {
    method = 'put'
    url = '/company/' + data.id
  }
  return request({
    url,
    method,
    data
  })
}

export function remove (id) {
  return request({
    url: '/company/' + id,
    method: 'delete',
  })
}
